export default __webpack_public_path__ + "static/AmitMidha-57ef386ce768c2cc13519de01b53b04a.png";